import { FC, useEffect, useState } from 'react';
import { CircularProgress, Tooltip } from '@mui/material';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import SmsIcon from '@mui/icons-material/Sms';
import TelegramIcon from '@mui/icons-material/Telegram';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ReviewModal from 'src/pages/Admin/Content/Modals/Reviews/Add';
import useIsMobile from 'src/hooks/useIsMobile';
import { useTypedSelector } from 'src/hooks/useTypeSelector';
import { IFeedback, IHostFetch } from 'src/models/IHost';
import { IOrderFetch } from 'src/models/IOrder';

interface IProps {
  order: IOrderFetch;
}

const CustomerDataHost: FC<IProps> = ({ order: { id, van, client, feedback } }) => {
  const isMobile = useIsMobile();
  const { role } = useTypedSelector(state => state.auth);
  const {
    host: { hostList }
  } = useTypedSelector(state => state);
  const [open, isOpen] = useState(false);
  const [currentHost, setCurrentHost] = useState<IHostFetch>();

  const newReview = {
    order_id: id,
    host_id: van.host_id,
    link: '',
    description: '',
    rates: 0
  } as IFeedback;

  useEffect(() => {
    const host = hostList.filter(h => h.id === van.host_id);
    setCurrentHost(host[0]);
  }, [hostList, id]);

  return (
    <>
      <div className='order-show__title'>
        Host
        <a
          href={`https://van.sprinter-rentals.com/host/reviews/${currentHost?.host_tag[0]}`}
          target='_blank'
          className='order-contact__subtitle'
        >
          See Profile
        </a>
      </div>
      <div className='order-contact__item'>
        {currentHost && currentHost.id === van.host_id ? (
          <div className='order-contact__host'>
            <div className='order-contact__name'>
              {currentHost.first_name} {currentHost.last_name}
            </div>
            {role === 'admin' && (
              <>
                <Tooltip title='Redirect to Gmail'>
                  <a
                    href={`https://mail.google.com/mail/?view=cm&source=mailto&to=${currentHost.email}&su=van trip ${id} needs you`}
                    target='_blank'
                    className='order-contact__host__link'
                  >
                    <AlternateEmailIcon />
                    <span>Email host</span>
                  </a>
                </Tooltip>
                <Tooltip title='Telegram host'>
                  <a
                    href={`https://t.me/${currentHost.phone}?text=Hello, needs your attention to order ${id}`}
                    target='_blank'
                    className='order-contact__host__link'
                  >
                    <TelegramIcon />
                    <span>Telegram host</span>
                  </a>
                </Tooltip>
              </>
            )}
            <Tooltip title={feedback[0] ? 'Edit Host Review' : 'Leave Host Review'}>
              <div className='order-contact__host__link' onClick={() => isOpen(true)}>
                <ThumbUpIcon />
                <span>{feedback[0] ? 'Edit Host Review' : 'Leave Host Review'}</span>
              </div>
            </Tooltip>
            {role === 'admin' && (
              <Tooltip title='SMS/text Host'>
                <a
                  href={
                    isMobile
                      ? `tel:${currentHost.phone}`
                      : `https://voice.google.com/u/0/messages?itemId=t.%2B${currentHost.phone}`
                  }
                  className='order-contact__host__link'
                  target={isMobile ? '_self' : '_blank'}
                >
                  <SmsIcon />
                  <span>SMS/text Host</span>
                </a>
              </Tooltip>
            )}
            {feedback.length ? (
              <div className='order-contact__host__feedback'>
                <p className='order-contact__host__feedback__title'>Your Review:</p>
                <p className='order-contact__host__feedback__text'>{feedback[0].description}</p>
              </div>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <CircularProgress size={15} />
        )}
      </div>
      <ReviewModal
        review={feedback[0] ?? newReview}
        open={open}
        handleClose={() => isOpen(false)}
        isEdit={!!feedback[0]}
      />
    </>
  );
};

export default CustomerDataHost;
